module.exports = __webpack_public_path__ + "media/announcement-sound.827898bb.mp3";